<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-title><font>ผู้ใช้งานระบบ</font></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <!-- เพิ่มผู้ใช้งานใหม่ -->
                    <template>
                        <!-- ปุ่มเพิ่มผู้ใช้งานใหม่ -->
                        <v-layout>
                            <v-flex>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn fab small dark v-on="on" @click="openNewUser"><v-icon>mdi-account-plus</v-icon></v-btn>
                                    </template>
                                    <span>เพิ่มผู้ใช้งานระบบ</span>
                                </v-tooltip>
                                <v-btn small outlined color="orange darken-2" class="ml-2" @click="groupDialog.open = true">
                                    <v-icon left small>mdi-account-group</v-icon>จัดการกลุ่ม
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <!-- ฟอร์มกรอกข้อมูลผู้ใช้งานใหม่ -->
                        <v-dialog v-model="showDialogNewUser" max-width="400px" persistent>
                            <v-card>
                                <v-card-title></v-card-title>
                                <v-card-text>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field v-model="emailNew" label="รหัสผู้ใช้ หรือ อีเมล:" ref="emailNew" required
                                            :rules="newLoginRules" color="orange accent-3"
                                            hint="ไม่มี @ = รหัสผู้ใช้ (ใช้ ลืมรหัสผ่าน? ไม่ได้)" persistent-hint></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field v-model="fullNameNew" label="ชื่อ-นามสกุล:" ref="fullNameNew" required
                                            :rules="fullNameRules" color="orange accent-3"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field v-model="password" label="Password:" ref="password" required
                                            :type="hidePass ? 'password' : 'text'"
                                            :append-icon="hidePass ? 'mdi-eye' : 'mdi-eye-off'" @click:append="hidePass = !hidePass"
                                            :rules="passwordRules" color="orange accent-3" autocomplete="new-password"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                    <v-layout>
                                        <v-flex text-right mr-1>
                                            <v-btn @click="addNewUser" color="green" dark>ตกลง</v-btn>
                                        </v-flex>
                                        <v-flex text-left ml-1>
                                            <v-btn color="red" @click="cancelNewUser" dark tabindex="-1">ยกเลิก</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                    <br>

                    <!-- แสดงผู้ใช้งานระบบ -->
                    <v-data-table :headers="headerUser" :items="detail" class="elevation-1" sort-by="custom.status"
                    :options.sync="tableOptions" :item-class="rowClass"
                    :loading="searchData && detail.length > 0" loader-height="3">
                        <template v-slot:no-data>
                            <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                            indeterminate></v-progress-linear>
                            <v-flex v-if="noData">
                                <strong><font color="red">ไม่พบข้อมูล</font></strong>
                            </v-flex>
                        </template>
                        <template v-slot:item.bookingGroup="{ item }">
                            {{ groupLabel(item.bookingGroup) }}
                            <v-chip v-if="item.supervisor" x-small color="orange" dark class="ml-1">หัวหน้า</v-chip>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <!-- A driver's account is managed on พนักงานขับรถ. Deleting it or
                                 changing its role here would leave driverAuth pointing at a
                                 missing user or an account without the driver claim, and a
                                 driver has no password to reset: see resetUserPassword. -->
                            <v-btn v-if="isDriver(item)" small text color="orange darken-3" :to="{ name: 'drivers' }">
                                <v-icon left small>mdi-card-account-details</v-icon>จัดการที่หน้าพนักงานขับรถ
                            </v-btn>
                            <v-tooltip bottom v-if="!isDriver(item) && canEditProfile(item)">
                                <template v-slot:activator="{ on }">
                                    <v-icon @click="openProfile(item)" v-on="on" class="mr-2">mdi-account-edit</v-icon>
                                </template>
                                <span>แก้ไขข้อมูลผู้ใช้</span>
                            </v-tooltip>
                            <template v-if="!isDriver(item) && item.custom.status != 'administrator'">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon @click="openResetPass(item)" v-on="on" class="mr-2">mdi-lock-reset</v-icon>
                                    </template>
                                    <span>รีเซ็ตรหัสผ่าน</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon @click="changeRole(item)" v-on="on" class="mr-2">mdi-account-convert</v-icon>
                                    </template>
                                    <span>เปลี่ยนสถานะผู้ใช้งานระบบ</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon @click="delUser(item)" v-on="on">mdi-delete-forever</v-icon>
                                    </template>
                                    <span>ลบผู้ใช้งานระบบ</span>
                                </v-tooltip>
                            </template>
                        </template>
                    </v-data-table>

                    <!-- Dialog เปลี่ยนสถานะผู้ใช้งานระบบ -->
                    <v-dialog v-model="dialogChangeRole" max-width="300px" persistent>
                        <v-card>
                            <v-card-title></v-card-title>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-text-field label="E-mail:" v-model="emailRole" color="orange accent-3" readonly></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-text-field label="สถานะปัจจุบัน:" v-model="lastRole" color="orange accent-3" readonly></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-select label="เลือกสถานะ:" :items="role" item-text="name" item-value="id"
                                        v-model="statusRole" color="orange accent-3" item-color="orange accent-3" 
                                        :rules="[v => !!v || 'กรุณาเลือกสถานะ']" ref="statusRole"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-card-actions>
                                    <v-layout>
                                        <v-flex text-right mr-1>
                                            <v-btn @click="addNewRole" color="green" dark>ตกลง</v-btn>
                                        </v-flex>
                                        <v-flex text-left ml-1>
                                            <v-btn color="red" @click="cancelChangeRole" dark tabindex="-1">ยกเลิก</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <!-- Dialog รีเซ็ตรหัสผ่าน -->
                    <v-dialog v-model="dialogResetPass" max-width="360px" persistent>
                        <v-card>
                            <v-card-title>รีเซ็ตรหัสผ่าน</v-card-title>
                            <v-card-text>
                                <v-text-field label="E-mail:" v-model="resetPass.email" color="orange accent-3" readonly></v-text-field>
                                <v-text-field v-model="resetPass.password" label="รหัสผ่านใหม่:" ref="resetPassword"
                                :type="resetPass.show ? 'text' : 'password'"
                                :append-icon="resetPass.show ? 'mdi-eye-off' : 'mdi-eye'"
                                @click:append="resetPass.show = !resetPass.show"
                                :rules="newPasswordRules" color="orange accent-3" autocomplete="new-password"></v-text-field>
                                <v-text-field v-model="resetPass.confirm" label="ยืนยันรหัสผ่านใหม่:" ref="resetConfirm"
                                :type="resetPass.show ? 'text' : 'password'"
                                :rules="[v => v === resetPass.password || 'รหัสผ่านไม่ตรงกัน']"
                                color="orange accent-3" autocomplete="new-password"></v-text-field>
                                <div class="caption grey--text text--darken-1">
                                    แจ้งรหัสผ่านนี้กับผู้ใช้งานโดยตรง ผู้ใช้งานจะถูกออกจากระบบในทุกอุปกรณ์ที่เข้าอยู่
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-layout>
                                    <v-flex text-right mr-1>
                                        <v-btn @click="confiResetPass" color="green" dark>ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left ml-1>
                                        <v-btn color="red" @click="cancelResetPass" dark tabindex="-1">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <!-- Dialog แก้ไขข้อมูลผู้ใช้ -->
                    <v-dialog v-model="profile.open" max-width="400px" persistent>
                        <v-card>
                            <v-card-title>แก้ไขข้อมูลผู้ใช้</v-card-title>
                            <v-card-text>
                                <v-text-field label="เข้าสู่ระบบปัจจุบันด้วย:" :value="profile.current" color="orange accent-3" readonly></v-text-field>
                                <v-text-field v-model="profile.fullName" label="ชื่อ-นามสกุล:" ref="profileName"
                                :rules="fullNameRules" color="orange accent-3"></v-text-field>
                                <!-- The login name, not a password: this dialog never sends one.
                                     "รหัส" alone reads as รหัสผ่าน to most users, hence the label. -->
                                <v-text-field v-model="profile.loginId" label="ชื่อเข้าสู่ระบบ (User ID):" ref="profileLogin"
                                :rules="loginIdRules" color="orange accent-3"
                                :hint="profile.currentLoginId
                                    ? 'ไม่ใช่รหัสผ่าน — แก้เฉพาะเมื่อต้องการเปลี่ยนชื่อที่ใช้เข้าระบบ'
                                    : 'ไม่ใช่รหัสผ่าน — เว้นว่างไว้ถ้าต้องการเข้าสู่ระบบด้วยอีเมลเดิม'" persistent-hint></v-text-field>
                                <div v-if="profileChangesLogin" class="caption orange--text text--darken-3 mt-3">
                                    เมื่อบันทึก ผู้ใช้จะถูกออกจากระบบในทุกอุปกรณ์ และต้องเข้าสู่ระบบใหม่ด้วยชื่อเข้าสู่ระบบ
                                    <strong>{{ normalizedLoginId }}</strong>
                                    บัญชีนี้จะใช้ "ลืมรหัสผ่าน?" ไม่ได้อีก ให้ผู้ดูแลระบบรีเซ็ตรหัสผ่านแทน
                                </div>
                                <v-divider class="my-4"></v-divider>
                                <v-select v-model="profile.bookingGroup" :items="groupOptions" label="กลุ่ม:"
                                color="orange accent-3" hide-details="auto"
                                @change="v => { if (!v) profile.supervisor = false }"></v-select>
                                <v-switch v-model="profile.supervisor" :disabled="!profile.bookingGroup"
                                label="หัวหน้ากลุ่ม (ยืนยันคำขอเลื่อน/ยกเลิกของทุกคนในกลุ่ม)" color="orange accent-3"
                                hide-details></v-switch>
                            </v-card-text>
                            <v-card-actions>
                                <v-layout>
                                    <v-flex text-right mr-1>
                                        <v-btn @click="saveProfile" color="green" dark>ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left ml-1>
                                        <v-btn color="red" @click="profile.open = false" dark tabindex="-1">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <!-- Dialog จัดการกลุ่ม -->
                    <v-dialog v-model="groupDialog.open" max-width="480px" persistent>
                        <v-card>
                            <v-card-title>จัดการกลุ่ม</v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <tbody>
                                        <tr v-for="g in groups" :key="g.id">
                                            <td>{{ g.label }}</td>
                                            <td class="grey--text">{{ g.id }}</td>
                                            <td class="text-right">
                                                <v-btn x-small text @click="editGroup(g)">แก้ไขชื่อ</v-btn>
                                                <v-btn x-small text :color="g.active === false ? 'green' : 'red'"
                                                    @click="saveGroup({ id: g.id, label: g.label, active: g.active === false })">
                                                    {{ g.active === false ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <v-row dense class="mt-3">
                                    <v-col cols="5">
                                        <v-text-field v-model="groupDialog.id" label="รหัสกลุ่ม (a-z)" :disabled="groupDialog.editing"
                                        color="orange accent-3" hide-details="auto"></v-text-field>
                                    </v-col>
                                    <v-col cols="7">
                                        <v-text-field v-model="groupDialog.label" label="ชื่อกลุ่ม"
                                        color="orange accent-3" hide-details="auto"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="groupDialog = { open: false, id: '', label: '', editing: false }">ปิด</v-btn>
                                <v-btn color="green" dark
                                    @click="saveGroup({ id: groupDialog.id, label: groupDialog.label })">
                                    {{ groupDialog.editing ? 'บันทึกชื่อ' : 'เพิ่มกลุ่ม' }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-card-text>
            </v-card>

            <!-- แจ้งเตือนต่าง ๆ -->
            <div>
                <!-- Dialog progress -->
                <v-dialog v-model="showDialogProgress" max-width="80" persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-progress-circular :size="30" color="orange accent-5" indeterminate></v-progress-circular>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>

                <!-- Dialog แจ้งเตือนก่อนกดยืนยันเปลี่ยนสถานะผู้ใช้งาน -->
                <v-dialog v-model="showChangeRole" :max-width="msgWarning.length*8" open-on-hover persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-icon color="yellow accent-4" :size="45">mdi-alert-circle-outline</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        {{msgWarning}}
                                    </v-flex>
                                </v-layout>
                                <br>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-right mr-1>
                                        <v-btn @click="confiChange" color="green" dark>ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left ml-1>
                                        <v-btn color="red" @click="showChangeRole = false" dark tabindex="-1">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>

                <!-- Dialog แจ้งเตือนก่อนกดยืนยันลบผู้ใช้งานระบบ -->
                <v-dialog v-model="showMsgDelUser" :max-width="msgWarning.length*8" open-on-hover persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-icon color="yellow accent-4" :size="45">mdi-alert-circle-outline</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        {{msgWarning}}
                                    </v-flex>
                                </v-layout>
                                <br>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-right mr-1>
                                        <v-btn @click="confiDelUser" color="green" dark>ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left ml-1>
                                        <v-btn color="red" @click="showMsgDelUser = false" dark tabindex="-1">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>

                <!-- Dialog บันทึกสำเร็จ -->
                <v-dialog v-model="showDialogSuccess" max-width="110" persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-icon color="green" :size="45">mdi-check-circle-outline</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        บันทึกสำเร็จ!
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>

                <!-- Dialog Error -->
                <v-dialog v-model="showDialogError" :max-width="msgError.length*7">
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-icon color="red" :size="45">mdi-close-circle-outline</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        {{msgError}}
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>
            </div>
        </v-container>
    </v-app>
</template>
<script>
import {functions} from '@/firebase'
import mainMenu from '@/components/mainMenu'
import userDirectory from '@/components/userDirectory'
import { reportError } from '@/components/report'
import { sortItems } from 'vuetify/lib/util/helpers'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            searchData: false,
            noData: true,
            showDialogProgress: false,
            showChangeRole: false,
            msgWarning: '',
            showDialogSuccess: false,
            showDialogError: false,
            msgError: '',
            showMsgDelUser: false,

            showDialogNewUser: false,
            emailNew: '',
            fullNameNew: '',
            password: '',
            hidePass: true,

            newLoginRules: [
                v => !!String(v || '').trim() || 'กรุณากรอกรหัสผู้ใช้หรืออีเมล',
                v => String(v || '').includes('@')
                    ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim()) || 'กรุณากรอกอีเมลให้ถูกต้อง'
                    : /^[a-z0-9][a-z0-9._-]{2,29}$/.test(String(v).trim().toLowerCase()) ||
                      'รหัสผู้ใช้ต้องยาว 3-30 ตัว ใช้ได้เฉพาะ a-z 0-9 . _ - และขึ้นต้นด้วยตัวอักษรหรือตัวเลข'
            ],
            passwordRules: [
                (v) => !!v || 'กรุณากรอกรหัสผ่านของท่าน',
            ],

            headerUser: [
                { text: 'รหัสผู้ใช้ / อีเมล', align: 'left', value: 'login' },
                { text: 'ชื่อ-นามสกุล', align: 'left', value: 'fullName' },
                { text: 'กลุ่ม', align: 'left', value: 'bookingGroup' },
                { text: 'สถานะ', align: 'left', value: 'custom.status' },
                { text: '', sortable: false, align: 'left', value: 'action' },
            ],
            detail: [],
            tableOptions: {},
            highlightUid: '',

            dialogChangeRole: false,
            emailRole: '',
            lastRole: '',

            role: [],
            statusRole: '',
            emailDel: '',

            dialogResetPass: false,
            resetPass: { uid: '', email: '', password: '', confirm: '', show: false },
            // Firebase Auth's own minimum; the resetUserPassword function checks it too.
            newPasswordRules: [
                v => !!v || 'กรุณากรอกรหัสผ่านใหม่',
                v => (v || '').length >= 6 || 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร'
            ],

            profile: { open: false, uid: '', current: '', currentLoginId: '', loginId: '', fullName: '', bookingGroup: '', supervisor: false },
            groups: [],
            groupDialog: { open: false, id: '', label: '', editing: false },
            // Mirrors functions/userProfile.js, which enforces it; this only
            // keeps the obvious mistakes from a round trip.
            loginIdRules: [
                v => !v || /^[a-z0-9][a-z0-9._-]{2,29}$/.test(String(v).trim().toLowerCase()) ||
                    'รหัสผู้ใช้ต้องยาว 3-30 ตัว ใช้ได้เฉพาะ a-z 0-9 . _ - และขึ้นต้นด้วยตัวอักษรหรือตัวเลข',
                v => !String(v || '').trim().toLowerCase().startsWith('driver-') || 'รหัสผู้ใช้ห้ามขึ้นต้นด้วย driver-'
            ],
            fullNameRules: [
                v => !!String(v || '').trim() || 'กรุณากรอกชื่อ-นามสกุล',
                v => String(v || '').trim().length <= 80 || 'ชื่อ-นามสกุลยาวเกิน 80 ตัวอักษร'
            ],
        }
    },
    computed:{
        normalizedLoginId(){
            return String(this.profile.loginId || '').trim().toLowerCase()
        },
        profileChangesLogin(){
            return !!this.normalizedLoginId && this.normalizedLoginId !== this.profile.currentLoginId
        },
        // An inactive group stays selectable only for a user already in it, so
        // a name edit does not have to move them out first.
        groupOptions(){
            const keep = this.profile.bookingGroup
            return [{ text: 'ไม่มีกลุ่ม', value: '' }].concat(this.groups
                .filter(g => g.active !== false || g.id === keep)
                .map(g => ({ text: g.label + (g.active === false ? ' (ปิดใช้งาน)' : ''), value: g.id })))
        },
        groupLabel(){
            const map = {}
            this.groups.forEach(g => { map[g.id] = g.label })
            return id => map[id] || id || '-'
        },
    },
    methods:{
        // The email seed-driver-auth.js and enableDriver give a driver's account, or
        // the claim. Mirrors credentialPolicy.isDriverAccount, which the functions
        // enforce; this only decides which buttons to draw.
        isDriver(item){
            return /^driver-[^@]+@delivery-kiosk\.local$/.test(item.email || '') ||
                (item.custom && item.custom.status === 'driver')
        },

        // The HttpsError message is written in Thai by the function; anything
        // else (network, a function not deployed yet) gets a generic line.
        showCallError(prefix, error){
            this.showDialogProgress = false
            const thai = error && error.message && /[฀-๿]/.test(error.message)
            this.msgError = prefix + ' : ' + (thai ? error.message : 'เชื่อมต่อระบบไม่ได้ โปรดลองใหม่')
            this.showDialogError = true
        },

        flashSuccess(){
            this.showDialogProgress = false
            this.showDialogSuccess = true
            setTimeout(() => { this.showDialogSuccess = false }, 2000)
        },

        openResetPass(item){
            this.resetPass = { uid: item.uid, email: item.email, password: '', confirm: '', show: false }
            this.dialogResetPass = true
            this.$nextTick(() => {
                this.$refs.resetPassword.resetValidation()
                this.$refs.resetConfirm.resetValidation()
                this.$refs.resetPassword.focus()
            })
        },

        cancelResetPass(){
            this.resetPass = { uid: '', email: '', password: '', confirm: '', show: false }
            this.dialogResetPass = false
        },

        confiResetPass(){
            if(!this.$refs.resetPassword.validate(true)){
                this.$refs.resetPassword.focus()
                return
            }
            if(!this.$refs.resetConfirm.validate(true)){
                this.$refs.resetConfirm.focus()
                return
            }
            this.showDialogProgress = true
            const resetUserPassword = functions.httpsCallable('resetUserPassword')
            resetUserPassword({ uid: this.resetPass.uid, password: this.resetPass.password })
            .then(() => {
                const uid = this.resetPass.uid
                this.cancelResetPass()
                this.flashSuccess()
                this.showRow(uid)
            })
            .catch(error => this.showCallError('รีเซ็ตรหัสผ่านไม่สำเร็จ', error))
        },

        // Only an administrator may edit an administrator -- setUserProfile
        // refuses it otherwise; this only decides whether to draw the icon.
        canEditProfile(item){
            if (item.custom.status !== 'administrator') return true
            return (this.$store.state.status || sessionStorage.status) === 'administrator'
        },

        openProfile(item){
            this.profile = {
                open: true,
                uid: item.uid,
                current: item.login,
                currentLoginId: item.loginId || '',
                loginId: item.loginId || '',
                fullName: item.fullName || '',
                bookingGroup: item.bookingGroup || '',
                supervisor: item.supervisor === true
            }
            this.$nextTick(() => {
                this.$refs.profileName.resetValidation()
                this.$refs.profileLogin.resetValidation()
                this.$refs.profileName.focus()
            })
        },

        saveProfile(){
            if(!this.$refs.profileName.validate(true)){
                this.$refs.profileName.focus()
                return
            }
            if(!this.$refs.profileLogin.validate(true)){
                this.$refs.profileLogin.focus()
                return
            }
            this.showDialogProgress = true
            const setUserProfile = functions.httpsCallable('setUserProfile')
            setUserProfile({ uid: this.profile.uid, loginId: this.normalizedLoginId, fullName: this.profile.fullName,
                bookingGroup: this.profile.bookingGroup,
                supervisor: !!this.profile.bookingGroup && this.profile.supervisor })
            .then(() => {
                this.profile.open = false
                this.flashSuccess()
                this.getUser(this.profile.uid)
            })
            .catch(error => this.showCallError('บันทึกไม่สำเร็จ', error))
        },

        // แสดงผู้ใช้งานระบบ
        // `showKey`, when given, is the uid or email of the account just created
        // or changed: once the list is back, the table turns to the page holding
        // it and marks the row. The old rows stay on screen while the list
        // reloads -- emptying them made Vuetify reset the table to page 1.
        getUser(showKey){
            this.searchData = true
            this.noData = false
            const listUser = functions.httpsCallable('listAllUser')
            listUser().then((doc) => {
                this.detail = (doc.data.userlist || []).map(u =>
                    Object.assign({ login: u.loginId || u.email }, u))
                this.searchData = false
                this.noData = this.detail.length === 0
                if (showKey) this.$nextTick(() => this.showRow(showKey))
            })
            .catch(error => {
                this.searchData = false
                this.noData = true
                alert('ไม่สามารถโหลดรายชื่อผู้ใช้งานได้ : ' + (error.message || error))
            })
        },

        // เปิด Dialog เพื่อเพิ่มผู้ใช้ใหม่
        openNewUser(){
            this.showDialogNewUser = true
            setTimeout(()=>{
                this.$nextTick(()=>this.$refs.emailNew.focus())
            },1)
        },

        // บันทึกผู้ใช้งานใหม่ -- newUser checks every rule and clash again.
        addNewUser(){
            if(!this.$refs.emailNew.validate(true)){
                this.$refs.emailNew.focus()
                return
            }
            if(!this.$refs.fullNameNew.validate(true)){
                this.$refs.fullNameNew.focus()
                return
            }
            if(!this.$refs.password.validate(true)){
                this.$refs.password.focus()
                return
            }
            const typed = String(this.emailNew).trim().toLowerCase()
            const payload = typed.includes('@')
                ? { email: typed, password: this.password, fullName: this.fullNameNew }
                : { loginId: typed, password: this.password, fullName: this.fullNameNew }
            this.showDialogProgress = true
            const newUser = functions.httpsCallable('newUser')
            newUser(payload)
            .then(res => {
                this.cancelNewUser()
                this.flashSuccess()
                this.getUser(res.data && res.data.email)
            })
            .catch(error => this.showCallError('เพิ่มผู้ใช้งานไม่สำเร็จ', error))
        },

        // ยกเลิกการเพิ่มผู้ใช้งานใหม่
        cancelNewUser(){
            this.emailNew = ''
            this.fullNameNew = ''
            this.password = ''
            this.hidePass = true
            this.showDialogNewUser = false
        },

        // Turn the table to the page holding this account and mark its row for a
        // few seconds. The page is worked out with Vuetify's own sortItems and the
        // table's current sort, so it lands where the table actually shows the row
        // even after someone re-sorted a column.
        // `key` is a uid (stable across a login-ID change) or, for an account
        // just created, the email newUser returned.
        showRow(key){
            const row = this.detail.find(u => u.uid === key || u.email === key)
            if (!row) return
            const o = this.tableOptions
            const sorted = sortItems(this.detail.slice(), o.sortBy || [], o.sortDesc || [], this.$vuetify.lang.current)
            const per = o.itemsPerPage
            if (per > 0) {
                this.tableOptions = Object.assign({}, o, { page: Math.floor(sorted.indexOf(row) / per) + 1 })
            }
            this.highlightUid = row.uid
            setTimeout(() => {
                if (this.highlightUid === row.uid) this.highlightUid = ''
            }, 6000)
        },

        rowClass(item){
            return item.uid === this.highlightUid ? 'orange lighten-4' : ''
        },

        // แสดง dialog เปลี่ยนสถานะผู้ใช้ระบบ
        changeRole(item){
            this.role = []
            let roleSt = [
                {id: 'admin', name: 'Admin'},
                {id: 'delivery', name: 'Delivery'},
                {id: 'shop', name: 'Shop'}
            ]
            this.emailRole = item.email
            this.lastRole = item.custom.status
            roleSt.forEach(rec=>{
                if(rec.id != item.custom.status){
                    this.role.push(rec)
                }
            })
            this.dialogChangeRole = true
        },

        // บันทึกการเปลี่ยนสถานะผู้ใช้
        addNewRole(){
            if(!this.$refs.statusRole.validate()){
                this.$refs.statusRole.focus()
            }
            else if(this.statusRole == this.lastRole){
                this.msgError = "ผู้ใช้นี้มีสถานะเป็น " + this.statusRole + " อยู่แล้ว"
                this.showDialogError = true
            }
            else{
                this.msgWarning = "คุณต้องการเปลี่ยนสถานะ " + this.$personName(this.emailRole) + " เป็น " + this.statusRole + " หรือไม่ ?"
                this.showChangeRole = true
            }
        },

        // ยกเลิกการเปลี่ยนสถานะ
        cancelChangeRole(){
            this.emailRole = ''
            this.lastRole = ''
            this.statusRole = ''
            this.dialogChangeRole = false
        },

        // ยืนยันการเปลี่ยนสถานะผู้ใช้
        confiChange(){
            this.showChangeRole = false
            this.showDialogProgress = true
            const addStatusRole = functions.httpsCallable('addStatusRole')
            addStatusRole({ email: this.emailRole, statusRole: this.statusRole })
            .then(() => {
                this.showDialogProgress = false
                this.showDialogSuccess = true
                // Read before cancelChangeRole clears it. The row can move to
                // another page under the สถานะ sort, so the table follows it.
                const email = this.emailRole
                setTimeout(() => {
                    this.showDialogSuccess = false
                    this.cancelChangeRole()
                    this.getUser(email)
                }, 2000)
            })
            .catch(error=>{
                alert(error)
            })
        },

        // ปุ่มลบผู้ใช้งานระบบ
        delUser(item){
            this.emailDel = item.email
            this.msgWarning = "คุณต้องการลบ " + (item.fullName || item.login) + " หรือไม่ ?"
            this.showMsgDelUser = true
        },

        // ยืนยันการลบผู้ใช้งานระบบ
        confiDelUser(){
            this.showChangeRole = false
            this.showDialogProgress = true
            this.showMsgDelUser = false
            const deleteUsers = functions.httpsCallable('deleteUsers')
            deleteUsers({ email: this.emailDel })
            .then(()=>{
                this.showDialogProgress = false
                this.showDialogSuccess = true
                setTimeout(() => {
                    this.showDialogSuccess = false
                    this.getUser()
                }, 2000)
            })
            .catch(error=>{
                alert(error)
            })
        },

        editGroup(g){
            this.groupDialog = { open: true, id: g.id, label: g.label, editing: true }
        },
        saveGroup(payload){
            this.showDialogProgress = true
            const setBookingGroup = functions.httpsCallable('setBookingGroup')
            setBookingGroup(payload)
            .then(() => {
                this.groupDialog = { open: true, id: '', label: '', editing: false }
                this.flashSuccess()
            })
            .catch(error => this.showCallError('บันทึกกลุ่มไม่สำเร็จ', error))
        },
    },
    mounted(){
        this.getUser()
        this.unsubGroups = userDirectory.subscribeGroups(g => { this.groups = g },
            err => reportError('bookingGroup subscription failed', err))
    },
    beforeDestroy(){
        if (this.unsubGroups) this.unsubGroups()
    }
}
</script>